import { combineReducers } from "redux";
import websocketReducer from "./websocket-reducer";
import sharedReducer from "./shared-reducer";
import staticDataReducer from "./static-data-reducer";
import navigationReducer from "./navigation-reducer";

/**
 * Root reducer
 * @namespace root_reducer
 * @category Redux
 * @subcategory Reducers
 */
// eslint-disable-next-line
const root_reducer = {};
//used for the namespace in the documentation

/**
 * Redux root reducer
 * @category Redux
 * @subcategory Reducers
 * @memberof root_reducer
 * @function rootReducer
 */
const rootReducer = combineReducers({
  websocket: websocketReducer,
  shared: sharedReducer,
  staticData: staticDataReducer,
  navigation: navigationReducer,
});

export default rootReducer;
